import React from "react";
import { Row, Col, Card } from "antd";
import LoaderGif from "../../assets/images/ie_loader.gif";

export default function DashboardStatsCard({
  inputText,
  value,
  loading,
  bg_img,
}) {
  return (
    <>
      <Row gutter={[0, 30]}>
        <Col
          sm={24}
          md={24}
          lg={24}
          xl={24}
          xs={24}
          style={{
            boxShadow: "1px 1px 1px lightgrey",
            marginTop: "1.5em",
            background: "white",
          }}
          className="dashboard-stats"
        >
          <Card
            // style={{
            //   background: `url(${bg_img})`,
            //   backgroundRepeat: "no-repeat",
            //   backgroundSize: "contain",
            //   height: "10em",
            //   padding: "3rem 1rem 3rem 1rem",
            //   margin: "auto",
            // }}
            style={{
              background: `url(${bg_img})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              height: "10em",
              padding: "2.5rem 0rem 2.5rem 0rem",
              margin: "auto",
              boxShadow: "0px 0px 5px 0px rgb(0 0 0 / 16%)",
            }}
          >
            <p
              style={{
                color: "#9e9e9e ",
                marginBottom: "5px",
              }}
            >
              <small
                style={{
                  fontSize: "83%",
                }}
              >
                {inputText}
              </small>
            </p>

            {loading ? (
              <img src={LoaderGif} height={"60"} width={"60"} />
            ) : (
              <h4
                style={{
                  color: "#444444",
                  fontSize: "2.28rem",
                  marginBottom: "0px",
                }}
              >
                {value}
              </h4>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
}
